import type { ReactNode } from 'react';
import { isApiError } from '@/api/errors';
import styles from './Alert.module.css';

interface AlertProps {
  tone?: 'error' | 'warning' | 'success' | 'info';
  children: ReactNode;
  action?: ReactNode;
}

export function Alert({ tone = 'info', children, action }: AlertProps) {
  return (
    <div className={`${styles.alert} ${styles[tone]}`} role={tone === 'error' ? 'alert' : 'status'}>
      <div className={styles.content}>{children}</div>
      {action}
    </div>
  );
}

/** An error from the API (or anything else thrown), with its request id for support. */
export function ErrorBanner({ error, action }: { error: unknown; action?: ReactNode }) {
  const message = error instanceof Error ? error.message : 'Something went wrong.';
  const requestId = isApiError(error) ? error.requestId : undefined;
  return (
    <Alert tone="error" action={action}>
      <span>{message}</span>
      {requestId && <span className={styles.reference}>Reference: {requestId}</span>}
    </Alert>
  );
}
